import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { WishlistProvider } from "@/context/WishlistContext";
import { ProductsProvider } from "@/context/ProductsContext";
import { SiteProvider } from "@/context/SiteContext";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import CartDrawer from "@/components/CartDrawer";
import Home from "@/pages/Home";
import Collections from "@/pages/Collections";
import ProductDetail from "@/pages/ProductDetail";
import CartPage from "@/pages/CartPage";
import Checkout from "@/pages/Checkout";
import Wishlist from "@/pages/Wishlist";
import Account from "@/pages/Account";
import About from "@/pages/About";
import Journal from "@/pages/Journal";
import JournalArticle from "@/pages/JournalArticle";
import OrderConfirmed from "@/pages/OrderConfirmed";
import TrackOrder from "@/pages/TrackOrder";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Contact from "@/pages/Contact";
import AdminMedia from "@/pages/AdminMedia";
import AdminProducts from "@/pages/AdminProducts";
import AdminHero from "@/pages/AdminHero";
import AdminOrders from "@/pages/AdminOrders";
import AdminCategories from "@/pages/AdminCategories";
import AdminSite from "@/pages/AdminSite";
import AdminNav from "@/pages/AdminNav";
import AdminJournal from "@/pages/AdminJournal";
import AdminDashboard from "@/pages/AdminDashboard";
import { Login, Signup, Forgot } from "@/pages/Auth";
import "@/App.css";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function Shell() {
  const { pathname } = useLocation();
  const transparent = pathname === "/";
  return (
    <>
      <Header transparent={transparent} />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/collections" element={<Collections />} />
          <Route path="/collections/:section" element={<Collections />} />
          <Route path="/category/:slug" element={<Collections />} />
          <Route path="/product/:slug" element={<ProductDetail />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/wishlist" element={<Wishlist />} />
          <Route path="/account" element={<Account />} />
          <Route path="/about" element={<About />} />
          <Route path="/journal" element={<Journal />} />
          <Route path="/journal/:slug" element={<JournalArticle />} />
          <Route path="/order-confirmed" element={<OrderConfirmed />} />
          <Route path="/track" element={<TrackOrder />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin/media" element={<AdminMedia />} />
          <Route path="/admin/products" element={<AdminProducts />} />
          <Route path="/admin/hero" element={<AdminHero />} />
          <Route path="/admin/orders" element={<AdminOrders />} />
          <Route path="/admin/categories" element={<AdminCategories />} />
          <Route path="/admin/site" element={<AdminSite />} />
          <Route path="/admin/nav" element={<AdminNav />} />
          <Route path="/admin/journal" element={<AdminJournal />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot" element={<Forgot />} />
        </Routes>
      </main>
      <Footer />
      <CartDrawer />
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <SiteProvider>
        <ProductsProvider>
          <WishlistProvider>
            <CartProvider>
              <BrowserRouter>
                <ScrollTop />
                <Shell />
                <Toaster position="bottom-right" toastOptions={{ style: { borderRadius: 0, background: "#0A0A0A", color: "#F9F9F6", border: "1px solid #0A0A0A" } }} />
              </BrowserRouter>
            </CartProvider>
          </WishlistProvider>
        </ProductsProvider>
      </SiteProvider>
    </AuthProvider>
  );
}
